import { Navigate, Outlet } from "react-router-dom";

import { ReactNode } from "react";

// ページ追加時に追加する
import {
  Form1,
  Form2,
  Form3,
  Form4,
  Form5,
  Form6,
  PlanSelectTop,
  PlanSelectComplete,
  Page404,
  PageServiceStop,
  Conditions,
  Agreement
} from "../components/";

// ページ追加する
export const ROUTES = {
  Default: "",
  LangForm1: "/:lang/form1",
  LangForm2: "/:lang/form2",
  LangForm3: "/:lang/form3",
  LangForm4: "/:lang/form4",
  LangForm5: "/:lang/form5",
  LangForm6: "/:lang/form6",
  LangPlanSelectTop: "/:lang/:id",
  LangPlanSelectConfirm: "/:lang/planselectconfirm",
  LangPlanSelectComplete: "/:lang/planselectcomplete",
  LangReservationCancelLogin: "/:lang/login",
  LangReservationCancelDetail: "/:lang/ReservationCancelDetail",
  LangReservationCancelFee: "/:lang/ReservationCancelFee",
  LangPage404: "/:lang/Page404",
  LangPageServiceStop: "/:lang/PageServiceStop",
  LangConditions: "/:lang/Conditions",
  LangAgreement: "/:lang/Agreement",
  LangFaq: "/:lang/Faq",
  Form1: "/form1",
  Form2: "/form2",
  Form3: "/form3",
  Form4: "/form4",
  Form5: "/form5",
  Form6: "/form6",
  PlanSelectTop: "/:id",
  PlanSelectConfirm: "/planselectconfirm",
  PlanSelectComplete: "/planselectcomplete",
  ReservationCancelLogin: "/login",
  ReservationCancelDetail: "/ReservationCancelDetail",
  ReservationCancelFee: "/ReservationCancelFee",
  Page404: "/Page404",
  PageServiceStop: "/PageServiceStop",
  Conditions: "/Conditions",
  Agreement: "/Agreement",
  Faq: "/Faq",
};
